import defaultState from "../../defaultState";
import { addRtmpLinkRoutine } from "../../actions/rtmp";

export const rtmpReducer = (state = defaultState.rtmp, action: any) => {
    switch (action.type) {
        case addRtmpLinkRoutine.TRIGGER:
            return [
                ...state,
                action.payload
            ]
        default:
            return state;
    }
}
